module.exports = __webpack_public_path__ + "img/teambox-freisteller@2x.b9cbe713.png";